import { render, staticRenderFns } from "./LeftPanel.vue?vue&type=template&id=36e74b22&scoped=true"
import script from "./LeftPanel.vue?vue&type=script&lang=js"
export * from "./LeftPanel.vue?vue&type=script&lang=js"
import style0 from "./LeftPanel.vue?vue&type=style&index=0&id=36e74b22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e74b22",
  null
  
)

export default component.exports